import {DateUtils, utils} from '@wallaby-ui/core';
import {format, parse} from 'date-fns';

export interface GetSummaryBoxDatesReturnType {
  currentIsoDate?: string;
  lastWeek?: string;
  olderThanLastWeek?: string;
  lastMonth?: string;
  olderThanLastMonth?: string;
  oldestIsoDate?: string;
}

export const getSummaryBoxDates = (
  currentDateString: string
): GetSummaryBoxDatesReturnType => {
  const currentDate = parse(
    currentDateString,
    DateUtils.ISO_DATE_ONLY_FORMAT,
    new Date()
  );
  let currentIsoDate;
  let oldestIsoDate;
  let lastWeek;
  let lastMonth;
  let olderThanLastWeek;
  let olderThanLastMonth;
  try {
    currentIsoDate =
      currentDate && format(currentDate, utils.DateUtils.ISO_DATE_ONLY_FORMAT);
    lastWeek =
      currentDate &&
      format(
        new Date(
          currentDate.getFullYear(),
          currentDate.getMonth(),
          currentDate.getDate() - 7
        ),
        utils.DateUtils.ISO_DATE_ONLY_FORMAT
      );
    olderThanLastWeek =
      currentDate &&
      format(
        new Date(
          currentDate.getFullYear(),
          currentDate.getMonth(),
          currentDate.getDate() - 8
        ),
        utils.DateUtils.ISO_DATE_ONLY_FORMAT
      );
    lastMonth =
      currentDate &&
      format(
        new Date(
          currentDate.getFullYear(),
          currentDate.getMonth(),
          currentDate.getDate() - 30
        ),
        utils.DateUtils.ISO_DATE_ONLY_FORMAT
      );
    olderThanLastMonth =
      currentDate &&
      format(
        new Date(
          currentDate.getFullYear(),
          currentDate.getMonth(),
          currentDate.getDate() - 31
        ),
        utils.DateUtils.ISO_DATE_ONLY_FORMAT
      );
    oldestIsoDate =
      currentDate && format(new Date(0), utils.DateUtils.ISO_DATE_ONLY_FORMAT);
  } catch (error) {
    if (error instanceof RangeError) {
      currentIsoDate = undefined;
      lastWeek = undefined;
      olderThanLastWeek = undefined;
      lastMonth = undefined;
      olderThanLastMonth = undefined;
      oldestIsoDate = undefined;
    } else {
      throw error;
    }
  }

  return {
    currentIsoDate,
    lastWeek,
    lastMonth,
    olderThanLastMonth,
    oldestIsoDate,
    olderThanLastWeek,
  };
};

type SearchParamsResultValue =
  | {
      filter: string;
    }
  | undefined;

export const dashboardSummaryBoxSearchParams = (
  dateFrom?: string,
  dateTo?: string,
  statesType?: string
) => {
  let result: SearchParamsResultValue;
  if (dateFrom && dateTo && statesType) {
    result = {
      filter: `date:'${dateFrom}' TO '${dateTo}' AND states:${statesType}`,
    };
  }
  return result;
};

export const dashboardChartsSearchParams = (
  dateFrom?: string,
  dateTo?: string,
  data?: string | number,
  dataType?: string
) => {
  let result: SearchParamsResultValue;
  if (dateFrom && dateTo && data) {
    result = {
      filter: `date:'${dateFrom}' TO '${dateTo}' AND states:REP, WIP AND ${dataType}:${data}`,
    };
  }
  return result;
};
